import { compose, withProps } from 'recompose'
import SizeDetails from './SizeDetails'
import toggle from 'components/common/hoc/toggle'
import { EXPANDABLE_AFTER } from './constants'

const withEnhancedProps = withProps(({ sizes, expanded }) => ({
  exceedsLimit: sizes.length > EXPANDABLE_AFTER,
  tireSizes: !expanded ? sizes.slice(0, EXPANDABLE_AFTER) : sizes
}))

export default compose(
  toggle,
  withEnhancedProps
)(SizeDetails)
